var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bbp-create-invoice",on:{"click":_vm.goToClientCard}},[_c('i',{staticClass:"bbp-icon-edit bbp-toolbar-icon bbp-create-invoice__icon"}),_vm._v(" "),_c('span',{staticClass:"bbp-create-invoice__text"},[_vm._v("Create Invoice")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3245f61c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/BBPTable/BBPCreateInvoice/BBPCreateInvoice.vue
// module id = null
// module chunks = 